// extracted by mini-css-extract-plugin
export default {"blogs":"Blogs_blogs__awdsI","story-title":"Blogs_story-title__QF0h0","copy-link-button":"Blogs_copy-link-button__gzGI6"};